import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
    marginTop: "-4px",
    zIndex: 999,
    [theme.breakpoints.down("xs")]: {
      marginRight: "-15px",
    },
  },
  person: {
    whiteSpace: "nowrap",
    color: "var(--color-primary-contrast)",
    fontSize: "13px !important",
    textTransform: "none",
    "& .MuiButton-startIcon": {
      "& > *": {
        fontSize: "13px !important",
      },
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      textAlign: "center",
      minWidth: "auto !important",
      padding: "6px !important",
      "& .MuiButton-label": {
        fontSize: "0 !important",
      },
      "& .MuiButton-startIcon": {
        margin: 0,
      },
    },
  },
  personicon: {
    fontSize: "13px !important",
  },
  hideProfileSetting: {
    display: "none",
  },
  nowrap: {
    whiteSpace: "nowrap",
  },
  InfoIcon: { fontSize: "14px", color: "gray" },
  themeMenuIcon: {
    minWidth: 36,
    color: "var(--color-text-secondary)",
  },
  themeMenuItem: {
    alignItems: "center",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  themeMenuText: {
    margin: 0,
  },
  themeMenuPrimary: {
    fontSize: "0.95rem",
    fontWeight: 500,
    lineHeight: 1.2,
    color: "var(--color-text-primary)",
  },
  themeMenuSecondary: {
    fontSize: "0.8rem",
    lineHeight: 1.25,
    marginTop: 2,
    color: "var(--color-text-secondary)",
  },
  userAvatar: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid rgba(255, 255, 255, 0.4)",
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    display: "block",
  },
  profileMenuList: {
    padding: theme.spacing(0.5, 0),
    width: "100%",
    boxSizing: "border-box",
  },
  profileHeaderItem: {
    padding: theme.spacing(1.25, 1.5),
    background: "linear-gradient(135deg, var(--color-primary-main) 0%, transparent 100%)",
    opacity: 0.9,
    cursor: "default",
  },
  profileHeaderLink: {
    padding: 0,
    paddingLeft: theme.spacing(0.5),
    width: "auto",
    flex: 1,
    minWidth: 0,
  },
  profileName: {
    fontSize: "0.95rem",
    fontWeight: 700,
    lineHeight: 1.25,
    color: "var(--color-text-primary)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  profileNameAsLink: {
    color: "var(--color-primary-main)",
    textDecoration: "underline",
    textDecorationColor: "transparent",
    textUnderlineOffset: "2px",
    transition: "text-decoration-color 0.2s ease",
    "$profileHeaderLink:hover &": {
      textDecorationColor: "var(--color-primary-main)",
    },
  },
  profileDesignation: {
    fontSize: "0.75rem",
    color: "var(--color-text-secondary)",
    marginTop: 2,
    lineHeight: 1.2,
  },
  profileMenuItem: {
    margin: theme.spacing(0.25, 0.75),
    paddingTop: theme.spacing(0.85),
    paddingBottom: theme.spacing(0.85),
    width: "auto",
    backgroundColor: "transparent !important",
    "&:hover": {
      backgroundColor: "transparent !important",
      "& .MuiListItemText-primary": {
        color: "var(--color-primary-main)",
      },
      "& $profileMenuItemIcon": {
        color: "var(--color-primary-main)",
        transform: "scale(1.08)",
      },
    },
    "&.MuiListItem-button:hover": {
      backgroundColor: "transparent",
    },
  },
  profileMenuItemIcon: {
    color: "var(--color-text-secondary)",
    marginRight: "10px",
    transition: "color 0.15s ease, transform 0.15s ease",
    "&.MuiSvgIcon-root": {
      fontSize: "1.25rem",
    },
  },
  profileMenuItemText: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "var(--color-text-primary)",
    transition: "color 0.15s ease",
  },
  profileLogoutItem: {
    "&:hover": {
      "& .MuiListItemText-primary": {
        color: "var(--error-color)",
      },
      "& $profileMenuItemIcon": {
        color: "var(--error-color)",
      },
    },
  },
  userInitials: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    border: "2px solid rgba(255, 255, 255, 0.4)",
    backgroundColor: "rgba(255, 255, 255, 0.18)",
    color: "#ffffff",
    fontSize: "13px !important",
    fontWeight: 700,
    letterSpacing: 0.4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "uppercase",
    lineHeight: 1,
  },
  avatarContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  syncIconBadge: {
    position: "absolute",
    bottom: 4,
    left: 4,
    backgroundColor: "var(--color-background-paper)",
    borderRadius: "50%",
    width: 18,
    height: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
    border: "1.5px solid var(--total_row_boldbackground)",
    zIndex: 2,
    "& svg": {
      fontSize: "0.85rem",
      color: "var(--color-primary-main)",
    },
  },
}));

export default useStyles;
